import script from "./VDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./VDropdown.vue?vue&type=script&setup=true&lang=js"

import "./VDropdown.vue?vue&type=style&index=0&id=193b05f6&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193b05f6"]])

export default __exports__